import React from 'react';
import { func, object, string } from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import { pathOr } from 'ramda';

import { ModalContent, ModalHeader, ModalBody } from '../../../../components/ModalSwimmy';
import { Emoji, IconArrowHead } from '../../../../components';

import css from './TypeView.module.css';

const TypeView = (props) => {
  const { className, formProps, formValues, handleView, intl } = props;
  const handlePrevious = () => {
    formProps.reset();
    handleView('LocationView');
  };
  const handleClick = (input) => {
    input.onChange(input.value);
    handleView('DateView');
  };
  const currentCity = pathOr('', ['location', 'selectedPlace', 'city'], formValues);
  const headingText = intl.formatMessage({ id: 'Search.TypeView.heading' });
  const allText = intl.formatMessage({ id: 'Search.TypeView.all' });
  const indoorText = intl.formatMessage({ id: 'Search.TypeView.indoor' });
  const jacuzziText = intl.formatMessage({ id: 'Search.TypeView.jacuzzi' });
  const classes = classNames(css.modalContent, className);

  return (
    <ModalContent className={classes}>
      <ModalHeader className={css.modalHeader}>
        <h1 className={css.heading}>{headingText}</h1>
        <button className={css.backButton} type="button" onClick={handlePrevious}>
          <IconArrowHead className={css.iconArrow} direction="left" />
        </button>
        <span className={css.location}>{currentCity}</span>
      </ModalHeader>
      <ModalBody className={css.modalBody}>
        <Field
          name="typeOfPool"
          type="radio"
          value="all"
          render={({ input }) => {
            return (
              <button className={css.button} type="button" onClick={() => handleClick(input)}>
                {allText}
                <Emoji className={css.emoji} symbol={0x1f3ca} />
              </button>
            );
          }}
        />
        <Field
          name="typeOfPool"
          type="radio"
          value="indoor"
          render={({ input }) => {
            return (
              <button className={css.button} type="button" onClick={() => handleClick(input)}>
                {indoorText}
                <Emoji className={css.emoji} symbol={0x1f3e0} />
              </button>
            );
          }}
        />
        <Field
          name="typeOfPool"
          type="radio"
          value="jacuzzi"
          render={({ input }) => {
            return (
              <button className={css.button} type="button" onClick={() => handleClick(input)}>
                {jacuzziText}
                <Emoji className={css.emoji} symbol={0x1f6c1} />
              </button>
            );
          }}
        />
      </ModalBody>
    </ModalContent>
  );
};

TypeView.defaultProps = {
  className: null,
  formProps: {},
  formValues: {},
};

TypeView.propTypes = {
  className: string,
  formProps: object,
  formValues: object,
  handleView: func.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(TypeView);
